export enum MobileViewTypes {
  map = 'map',
  list = 'list',
}
